// extracted by mini-css-extract-plugin
module.exports = {"comp":"TabSwiper_comp__akfme"};